import LegalPageLayout from '@/components/feature/LegalPageLayout';

export default function ReturnPolicyPage() {
  return (
    <LegalPageLayout title="İptal ve İade Politikası">
      <h4>1. Genel İade Koşulları</h4>
      <p>Atak Sistem Enerji olarak müşteri memnuniyetini ön planda tutuyoruz. İade ve iptal işlemleri, 6502 sayılı Tüketicinin Korunması Hakkında Kanun kapsamında değerlendirilmektedir.</p>

      <h4>2. Cayma Hakkı Süresi</h4>
      <p>Alıcı, ürün teslim tarihinden itibaren 14 gün içinde cayma hakkını kullanabilir. Hizmet sözleşmelerinde bu süre sözleşmenin kurulduğu tarihten itibaren başlar.</p>

      <h4>3. İade Şartları</h4>
      <ul>
        <li>İade edilecek ürünün kullanılmamış, hasar görmemiş ve orijinal ambalajında olması gerekmektedir.</li>
        <li>Montajı/kurulumu tamamlanmış ürünlerde cayma hakkı kullanılamaz.</li>
        <li>Alıcının özel talebi doğrultusunda üretilen veya kişiselleştirilen ürünler iade kapsamı dışındadır.</li>
      </ul>

      <h4>4. İade Süreci</h4>
      <p>İade talebinizi WhatsApp veya telefon üzerinden bize iletebilirsiniz. Talebiniz değerlendirildikten sonra iade süreci başlatılacak ve ürün bedeli, iade onayından itibaren 14 gün içinde iade edilecektir.</p>

      <h4>5. İptal ve Sipariş Değişikliği</h4>
      <p>Siparişiniz kargoya verilmeden veya kurulum planlanmadan önce iptal talebinde bulunabilirsiniz. Kurulum planlanmış siparişlerde iptal koşulları için bizimle iletişime geçiniz.</p>

      <h4>6. İletişim</h4>
      <p>İade ve iptal işlemleri için WhatsApp veya 0266 246 41 59 numaralı telefondan bize ulaşabilirsiniz.</p>
    </LegalPageLayout>
  );
}